/**
 * Row styling helpers for service detail table
 */
import type { ServiceDetailRow } from './types'

/**
 * Get CSS class name for service detail row
 */
export const getRowClassName = (row: ServiceDetailRow): string => {
    switch (row._rowType) {
        case 'addon':
            return 'bg-blue-50/50'
        case 'total':
            // Use [&>td] selector to override cell background
            return 'border-t-2 border-primary/20 [&>td]:!bg-primary/5'
        default:
            return ''
    }
}
